module.exports = __webpack_public_path__ + "img/Blank.1592b743.svg";